export default __webpack_public_path__ + "static/media/admin_role.6dd119c3.png";